import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { NgxSpeedGraderComponent } from '@go-modules/components/feedback-session/speed-grader/speed-grader.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule
	],
	declarations: [
		NgxSpeedGraderComponent
	],
	exports: [
		NgxSpeedGraderComponent
	],
	providers: [
		TranslatePipe
	]
})
export class SpeedGraderModule {}
